import { createSelector } from 'reselect';
import { sortFilesByName } from '../utils';

const hostFilesSelector = createSelector(
  (state) => state.hostFiles,
  (hostFiles) => hostFiles,
);

export const config = createSelector(hostFilesSelector, (hf) => hf.config);
export const files = createSelector(hostFilesSelector, (hf) => hf.files);
export const counts = createSelector(hostFilesSelector, (hf) => hf.counts);
export const isLoading = createSelector(hostFilesSelector, (hf) => hf.isLoading);
export const isUploading = createSelector(hostFilesSelector, (hf) => hf.isUploading);
export const uploadProgress = createSelector(hostFilesSelector, (hf) => hf.uploadProgress);
export const uploadFileIndex = createSelector(hostFilesSelector, (hf) => hf.uploadFileIndex);
export const uploadFileCount = createSelector(hostFilesSelector, (hf) => hf.uploadFileCount);
export const isUpdating = createSelector(hostFilesSelector, (hf) => hf.isUpdating);
export const error = createSelector(hostFilesSelector, (hf) => hf.error);
export const success = createSelector(hostFilesSelector, (hf) => hf.success);

export const groupedFiles = createSelector(files, (filesList) => {
  const groups = {};
  (filesList || []).forEach((file) => {
    (file.listing_ids || []).forEach((lid) => {
      if (!groups[lid]) groups[lid] = [];
      groups[lid].push(file);
    });
  });
  Object.keys(groups).forEach((lid) => {
    groups[lid] = sortFilesByName(groups[lid]);
  });
  return groups;
});

export default hostFilesSelector;
